module.exports = __webpack_public_path__ + "media/images/exclamation-96c74259a823983cc0e673e06b514eaa.png";